<div *ngIf="invoice" class="container">
  <div class="text-center mb-3">
    <div class="d-flex justify-content-center align-items-center">
      <span class="font-weight-bold invoice_header mr-2" translate [translateParams]="{number: invoice.number}">invoice.invoiceNumber</span>
      <div>
        <span *ngIf="['info','prepaid'].includes(invoice.type) && invoice.closed" class="badge badge-pill badge-success" translate>invoice.closed</span>
        <span *ngIf="['info','prepaid'].includes(invoice.type) && !invoice.closed" style="font-size: .87rem;" class="badge badge-pill badge-light" translate>invoice.opened</span>
        <span *ngIf="invoice.type === 'postpaid' && invoice.closed" class="badge badge-pill badge-success" translate><i class="fa fa-dollar-sign mr-2"></i>invoice.paid</span>
        <div *ngIf="invoice.type === 'postpaid' && !invoice.closed && +invoice.paidAmount === 0">
          <span style="font-size: .87rem;" class="badge badge-pill badge-light" translate>invoice.opened</span>
        </div>
        <div *ngIf="invoice.type === 'postpaid' && isPartialPaid(invoice)">
          <span class="badge badge-pill badge-warning" translate><i class="fa fa-dollar-sign mr-2"></i>Partial</span>
        </div>
      </div>
    </div>
    <p>{{invoice.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
  </div>

  <div>
    <div class="font-weight-bold mid_size ml-5 mb-3" translate>invoice.items</div>

    <div class="d-flex justify-content-between align-items-center custom_card">
      <div class="d-flex">
        <div class="button_container" (click)="onLoadInvoice(selectedUserId)" [ngbTooltip]="'Refresh'">
          <i class="fa fa-sync-alt"></i>
        </div>
        <div *ngIf="invoice.csvLink" class="button_container" (click)="downloadFile()" [ngbTooltip]="'Download CSV'">
          <i class="fa fa-download"></i>
        </div>
        <button  *ngIf="invoice.csvStatus !== 'outdated' && this.client?.customInvoiceConfig?.columns?.length" class="custom-button generate_csv font-weight-bold" (click)="generateCSV()" translate>invoice.generateCsv</button>
      </div>
      <div *ngIf="isClientInvoice" class="search_container">
        <i style="cursor: pointer;" class="fa fa-search gray-text" (click)="onLoadInvoice(selectedUserId)"></i>
        <input id="users" autocomplete="off" (keydown.enter)="onSearch($event)" (input)="searchUsers($event)" name="user" class="search_input" type="text" [attr.placeholder]="'invoice.filterByUser' | translate">
        <div class="users_container" *ngIf="users.length">
          <div class="card m-0">
            <div class="p-2 mb-1" *ngFor="let user of users" (click)="selectUser(user)">
              <p>{{user.name}}</p>
              <p class="small">{{user.email}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom_card blue_color d-flex align-items-center" *ngIf="invoice.csvStatus === 'outdated' && invoice.csvLink">
      <i class="fa fa-info-circle blue-text"></i>
      <p class="mx-2 font-weight-bold small" translate>invoice.outdatedCsv</p>
      <button class="custom-button generate_csv" (click)="generateCSV()" translate>invoice.generateCsv</button>
    </div>

    <div  class="custom_card blue_color d-flex align-items-center" *ngIf="invoice.csvStatus === 'pending' || (invoice.csvStatus === 'outdated' && !invoice.csvLink)">
      <i class="fa fa-info-circle blue-text"></i>
      <p class="mx-2 font-weight-bold small" translate>invoice.generateCsvInfo</p>
      <button class="custom-button generate_csv" (click)="generateCSV()" translate>invoice.generateCsv</button>
    </div>

    <div class="custom_card blue_color d-flex align-items-center" *ngIf="invoice.csvStatus === 'in_progress'">
      <p class="mr-3" translate>invoice.csvInProgress</p>
      <div class="loader">Loading...</div>
    </div>

    <div *ngIf="items && items.results.length" class="custom_card">

      <div class="d-flex justify-content-end align-items-end">
        <p class="number-vehicles">{{ lower }}-{{ upper }} <span style="font-weight: 100;" translate>vehicles.of</span>
          {{ items.count }} <span style="font-weight: 100;" translate>items</span></p>
      </div>

      <div style="overflow-x:auto;">
        <table id="customers" class="my-3">
          <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Email</th>
              <th scope="col">Type</th>
              <th scope="col">VIN</th>
              <th scope="col">Images</th>
              <th scope="col">Credits</th>
              <th scope="col">Additional Invoice Info</th>
              <th style="width: 210px;" scope="col" *ngIf="isClientInvoice">Features</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items.results">
              <td scope="row" data-label="Date">{{item.timestamp | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
              <td data-label="Email" [ngClass]="{ 'white_color': !item.email }">{{item?.email ? item.email : '/'}}</td>
              <td data-label="Type"><span [ngClass]="{ 'transfer': ['transfer', 'feature'].includes(item.type) }" class="badge badge-pill blue_color badge_type" (click)="seeReason(item)">{{item.type}}</span></td>
              <td data-label="VIN" [ngClass]="{ 'white_color': !item.vin }">{{item.vin ? item.vin : '/'}}</td>
              <td data-label="Images" [ngClass]="{ 'white_color': item.imagesCount === null }">{{item.imagesCount !== null ? item.imagesCount : '/'}}</td>
              <td data-label="Credits">{{item.price}}</td>
              <td data-label="Additional Invoice Info">{{item.additionalInvoiceInfo}}</td>
              <td style="font-size: .94rem;" data-label="Features" *ngIf="isClientInvoice" [ngClass]="{ 'white_color': !item.featuresArray.length }">{{item?.featuresArray.length ? item?.featuresArray.join(', ') : '/'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <div class="per_page">
          <span>Show: </span>
          <select class="form-control select-custom" name="" id="" [(ngModel)]="perPage" (change)="changePerPage($event)">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
          </select>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <ngb-pagination [collectionSize]="items.count" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5"
            [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
        </div>
      </div>
    </div>

    <div *ngIf="items && !items.results.length" class="custom_card font-weight-bold">
      No items.
    </div>

    <div class="custom_card">
        <div class="d-flex justify-content-end">
          <p translate>invoice.creditsCost</p>
          <span class="ml-3">{{invoice.amount}}</span>
        </div>
        <div *ngIf="currentUser.role.name !== 'user' && invoice.type === 'postpaid'" class="d-flex justify-content-end">
          <p translate>invoice.creditsFromAccount</p>
          <span class="ml-3">{{invoice.credits}}</span>
        </div>
        <div *ngIf="invoice.type === 'postpaid' && isPartialPaid(invoice)" class="d-flex justify-content-end">
          <p class="font-weight-bold" translate>invoice.creditsPaid</p>
          <span class="ml-3 font-weight-bold">{{invoice.paidAmount}}</span>
        </div>
        <hr *ngIf="invoice.type === 'postpaid'">
        <div *ngIf="invoice.type === 'postpaid'" style="font-weight: bold;">
          <div class="d-flex justify-content-end" *ngIf="!invoice.closed">
            <p translate>invoice.totalToPay</p>
            <span class="ml-3">{{invoice.amount - invoice.credits - +invoice.paidAmount}}</span>
          </div>
          <div class="d-flex justify-content-end" *ngIf="invoice.closed">
            <p translate>invoice.paid</p>
            <span class="ml-3">{{+invoice.paidAmount}}</span>
          </div>
        </div>
      <div class="d-flex justify-content-end mt-4">
        <button class="custom-button pay_button" *ngIf="!['client'].includes(currentUser.role.name) && invoice.type === 'postpaid' && !invoice.closed" (click)="onPay()" translate>invoice.pay</button>
        <button class="custom-button pay_button" *ngIf="currentUser.role.name !== 'client' && invoice.type !== 'postpaid' && !invoice.closed" (click)="onPay()" translate>invoice.close</button>
      </div>
    </div>

  </div>
</div>

<app-modal (close)="togglePay = !togglePay" *ngIf="togglePay">
  <div class="modal_container black-text">
    <div class="modal-header">
      <h4 class="modal-title" translate>crop.areYouSure</h4>
    </div>
    <div class="modal-body">
     <div class="d-flex justify-content-between">
       <form class="d-flex" *ngIf="invoice.type === 'postpaid'" #payInvoiceForm="ngForm">
         <div>
           <input type="text" name="amount" ngModel class="form-control" [attr.placeholder]="'invoice.amountToPay' | translate">
         </div>
         <button style="min-width: 80px;" *ngIf="invoice.type === 'postpaid'" class="custom-button ml-2" (click)="payInvoice(payInvoiceForm)" translate>invoice.pay</button>
      </form>
      <div>
        <button *ngIf="invoice.type !== 'postpaid'" class="custom-button mr-2" (click)="closeInvoice()" translate>invoice.close</button>
        <button class="custom-button" (click)="togglePay = false;" translate>global.cancel</button>
      </div>
     </div>
    </div>
  </div>
</app-modal>

<!-- <div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Please wait...'"></div>
</div> -->

<app-modal (close)="toggleCsvInfo = !toggleCsvInfo" *ngIf="toggleCsvInfo">
  <div class="modal_container black-text">
    <div class="modal-body">
      <p translate>invoice.csvIsGenerating</p>
      <div class="d-flex justify-content-end">
       <button class="custom-button" (click)="toggleCsvInfo = false;">OK</button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal (close)="showReason = !showReason" *ngIf="showReason">
  <div class="modal_container black-text">
    <div class="modal-body">
      <p>{{reason}}</p>
      <div class="d-flex justify-content-end">
       <button class="custom-button" (click)="showReason = false;">OK</button>
      </div>
    </div>
  </div>
</app-modal>

<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Loading...'"></div>
</div>

<app-modal (close)="toggleGenerateCsvOptions = !toggleGenerateCsvOptions" *ngIf="toggleGenerateCsvOptions">
  <div class="modal_container black-text">
    <div class="modal-body text-center">
      <p class="font-weight-bold">Choose option</p>
      <form class="d-flex flex-column align-items-center" #generateCsvForm="ngForm" (ngSubmit)="clientCSVGenerate(generateCsvForm)">
        <div class="row my-3">
          <label class="col-12">
            <input ngModel type="radio" name="customInvoiceConfigEnable" [value]="true" required> Custom Invoice Configuration
          </label>
          <label class="col-12">
            <input ngModel type="radio" name="customInvoiceConfigEnable" [value]="false" required> Default Invoice
          </label>
        </div>
        <button type="submit" class="custom-button btn-red mt-3" style="font-size: 1.2rem;">Save</button>
      </form>
    </div>
  </div>
</app-modal>

<app-modal (close)="toggleNameOfClientInvoice = !toggleNameOfClientInvoice" *ngIf="toggleNameOfClientInvoice">
  <div class="modal_container black-text">
    <div class="modal-body text-center">
      <p class="font-weight-bold">Invoice Name</p>
      <form class="d-flex flex-column align-items-center" #clientInvoiceName="ngForm" (ngSubmit)="nameOfClientInvoice(clientInvoiceName)">
        <div class="row my-3">
          <label class="col-12 custom-checkbox">
            <input ngModel class="custom-checkbox-input" type="checkbox" ngModel name="clientNameInclude" [value]="true"> <span class="custom-checkbox-text">Add the client's name</span>
          </label>
        </div>
        <button type="submit" class="custom-button btn-red" style="font-size: 1.2rem;">Save</button>
      </form>
    </div>
  </div>
</app-modal>